<mat-chip-list class="chip">
  <mat-chip *ngFor="let tag of tags" color="primary" selected (click)="getEventsByCategory2(tag)"
    >{{ tag }}
  </mat-chip>
</mat-chip-list>
